exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outerbox{color:#191818}.ruleBox{display:flex}.circle{width:11px;height:11px;background:linear-gradient(90deg,#4869d3,#0e85d6);border-radius:50%}.circle--single{margin-right:22px}.circle--first{margin-top:4px}.line{height:28px}.fullLine,.line{width:26px;border-left:1px solid gray;margin-left:5px}.fullLine{height:100%}.rule{margin:0;padding:0;align-self:center}.rule:first-letter{text-transform:uppercase}.rule--first{align-self:flex-start}.rule--last{align-self:flex-end;margin-bottom:-4px}.conjunction{transform:translateX(-22%);font-size:11px}", ""]);

// exports
